import { useEffect, useMemo, useState } from 'react';
import { api } from '../../../lib/api';
import { Product } from '../../../types/products';

export function useProductsList() {
  const [items, setItems] = useState<Product[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchAll = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get<{ data: Product[] }>("/products");
      setItems(res.data);
    } catch (e: any) {
      setError(e.message || 'Failed to load products');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter(x =>
      x.name.toLowerCase().includes(q) ||
      (x.sku || '').toLowerCase().includes(q)
    );
  }, [items, query]);

  const total = filtered.length;
  const start = (page - 1) * pageSize;
  const end = start + pageSize;
  const pageData = filtered.slice(start, end);

  const remove = async (id: string) => {
    await api.delete(`/products/${id}`);
    await fetchAll();
  };

  return {
    items: pageData,
    total,
    page,
    pageSize,
    setPage,
    setPageSize,
    query,
    setQuery,
    loading,
    error,
    refresh: fetchAll,
    remove,
  };
}
